import { FC } from 'react'

import { Document, Font } from '@react-pdf/renderer'

import { DownloadPdfButtonProps } from 'src/Pages/Calculator/DownloadPdfButton.tsx'
import GeometriaRegular from 'src/Assets/Fonts/geometria.ttf'
import GeometriaLightItalic from 'src/Assets/Fonts/geometria_lightitalic.otf'
import GeometriaBold from 'src/Assets/Fonts/geometria_bold.otf'
import GeometriaBoldItalic from 'src/Assets/Fonts/geometria_bolditalic.otf'
import GeometriaMedium from 'src/Assets/Fonts/geometria_medium.otf'
import GeometriaMediumItalic from 'src/Assets/Fonts/geometria_mediumitalic.otf'

import { AdditionInfoPage } from './AdditionInfoPage'
import { CalculationPage } from './CalculationPage'
import { DescriptionAndEquipmentsPage } from './DescriptionAndEquipmentsPage'

Font.register({
  family: 'Geometria',
  src: GeometriaRegular,
})

Font.register({
  family: 'Geometria',
  src: GeometriaLightItalic,
  fontStyle: 'italic',
})

Font.register({
  family: 'Geometria',
  src: GeometriaBold,
  fontWeight: 'bold',
})

Font.register({
  family: 'Geometria',
  src: GeometriaBoldItalic,
  fontWeight: 'bold',
  fontStyle: 'italic',
})

Font.register({
  family: 'Geometria',
  src: GeometriaMedium,
  fontWeight: 600,
})

Font.register({
  family: 'Geometria',
  src: GeometriaMediumItalic,
  fontWeight: 600,
  fontStyle: 'italic',
})

export interface OfferProps {
  offerNumber: DownloadPdfButtonProps['offerNumber']
  offerEquipments?: DownloadPdfButtonProps['offerEquipments']
  clientContactName: DownloadPdfButtonProps['clientContactName']
  clientContactNamePosition: DownloadPdfButtonProps['clientContactNamePosition']
  clientName: DownloadPdfButtonProps['clientName']
  clientDivision: DownloadPdfButtonProps['clientDivision']
  minRentPeriod: DownloadPdfButtonProps['minRentPeriod']
  validityDaysCount?: DownloadPdfButtonProps['validityDaysCount']
  withoutMedicalExamination?: DownloadPdfButtonProps['withoutMedicalExamination']
  isWorkService?: DownloadPdfButtonProps['isWorkService']
  personalBenefits?: DownloadPdfButtonProps['personalBenefits']
  privilegesData?: DownloadPdfButtonProps['privilegesData']
  introductionText?: DownloadPdfButtonProps['introductionText']
  firstName: DownloadPdfButtonProps['firstName']
  lastName: DownloadPdfButtonProps['lastName']
  email: DownloadPdfButtonProps['email']
  phone: DownloadPdfButtonProps['phone']
  offerDate: DownloadPdfButtonProps['offerDate']
  isMobDemob?: DownloadPdfButtonProps['isMobDemob']
  vatRate?: DownloadPdfButtonProps['vatRate']
}

export const Offer: FC<OfferProps> = ({
  offerNumber,
  offerEquipments = [],
  clientContactName,
  clientContactNamePosition,
  clientName,
  clientDivision,
  minRentPeriod,
  validityDaysCount,
  withoutMedicalExamination,
  isWorkService,
  personalBenefits,
  privilegesData,
  introductionText,
  firstName,
  lastName,
  email,
  phone,
  offerDate,
  isMobDemob,
  vatRate,
}) => {
  return (
    <Document>
      <DescriptionAndEquipmentsPage
        offerNumber={offerNumber}
        offerEquipments={offerEquipments}
        clientContactName={clientContactName}
        clientContactNamePosition={clientContactNamePosition}
        clientName={clientName}
        clientDivision={clientDivision}
        introductionText={introductionText}
        offerDate={offerDate}
        phone={phone}
      />

      <CalculationPage
        offerEquipments={offerEquipments}
        minRentPeriod={minRentPeriod}
        isMobDemob={isMobDemob}
        vatRate={vatRate}
      />

      <AdditionInfoPage
        validityDaysCount={validityDaysCount}
        isWorkService={isWorkService}
        medicalExamination={!withoutMedicalExamination}
        personalBenefits={personalBenefits}
        privilegesData={privilegesData}
        firstName={firstName}
        lastName={lastName}
        email={email}
        phone={phone}
      />
    </Document>
  )
}
